import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { ProjectSettingsServicedeskProactiveSupportSensorDetailsAppExtraProps } from './projectSettingsServicedeskProactiveSupportSensorDetails.entrypoint.types.tsx';

type ProjectSettingsServicedeskProactiveSupportSensorDetailsAppEntryPointProps =
	EntryPointComponent<
		Record<string, never>,
		Record<string, never>,
		{},
		ProjectSettingsServicedeskProactiveSupportSensorDetailsAppExtraProps
	>;

export const projectSettingsServicedeskProactiveSupportSensorDetailsAppEntryPoint: EntryPoint<
	ProjectSettingsServicedeskProactiveSupportSensorDetailsAppEntryPointProps,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<ProjectSettingsServicedeskProactiveSupportSensorDetailsAppEntryPointProps>(
		/* webpackChunkName: "async-project-settings-proactive-support-sensor-details", jiraSpaEntry: "async-project-settings-proactive-support-sensor-details" */
		'./ProjectSettingsServicedeskProactiveSupportSensorDetailsApp.tsx',
	),
	getPreloadProps: ({ context: { match } }: EntryPointRouteParams) => {
		return {
			extraProps: {
				projectKey: String(match.params.projectKey ?? ''),
				sensorId: String(match.params.sensorId ?? ''),
			},
		};
	},
});
